// Honestly no idea what this is doing. Frontend already defer loads the script in its global layout.
// All this does is fetch the script and does nothing with it.
export const initGoogleSignIn = () => {
  // Don't need JQuery here, but keeping it for consistency with the original code
  // and to avoid breaking changes. The below could be replaced with fetch
  // and DOM manipulation if needed.

  // Check if the Google root element is already present
  // If not, load the Google API script and append the body element
  if ($("#google-root").length === 0) {
    $.getScript("https://accounts.google.com/gsi/client");
    $("body").append("<div id='google-root'></div>");
  }
};

/**
 *
 * @description This function initializes the Google Sign-In token client.
 * @param {object} options - The options for initializing the token client.
 * @param {string} options.clientId - The google client ID for authing with google.
 * @param {string} options.nextUrl - The URL to redirect to after successful login.
 * @returns googleTokenClient
 */
export const initGoogleSignInTokenClient = ({ clientId, nextUrl }) => {
  return window?.google?.accounts.oauth2.initTokenClient({
    client_id: clientId,
    scope: "profile openid email", // The things we want to retrieve from Google login.
    callback: response => {
      if (response.access_token) {
        const data = {
            token: response.access_token,
            type: "google",
            redirect: true
          },
          dataStr = encodeURIComponent(JSON.stringify(data));

        // check for window, and throw error if no window
        window.location.href =
          "/oauth-auth?nextUrl=" +
          wattpad.utils.getNextUrl(nextUrl, window.location.href) +
          "&data=" +
          dataStr;
      }
    }
  });
};
